import { getApiBase, getAuthHeaders, readJsonResponse, type StorageScope } from './apiConfig';
import type { CreateEmbedShareInput, EmbedShare } from '@/types/embed.types';

const json = readJsonResponse;

export async function listEmbedShares(folderPath?: string, storageScope?: StorageScope): Promise<EmbedShare[]> {
  const params = new URLSearchParams();
  if (folderPath !== undefined) params.set('path', folderPath);
  const suffix = params.toString() ? `?${params}` : '';
  const res = await fetch(`${getApiBase()}/api/embed/shares${suffix}`, {
    headers: await getAuthHeaders({ storageScope }),
  });
  const body = await json(res);
  return body.shares || [];
}

export async function createEmbedShare(input: CreateEmbedShareInput, storageScope?: StorageScope): Promise<EmbedShare> {
  const res = await fetch(`${getApiBase()}/api/embed/shares`, {
    method: 'POST',
    headers: { ...(await getAuthHeaders({ storageScope })), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  const body = await json(res);
  return body.share;
}

export async function revokeEmbedShare(id: string, storageScope?: StorageScope): Promise<EmbedShare> {
  const res = await fetch(`${getApiBase()}/api/embed/shares/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: await getAuthHeaders({ storageScope }),
  });
  const body = await json(res);
  return body.share;
}
